import { useState, useEffect, useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export enum modelCatalogeTabTypes {
  TRAINING_JOBS = "training_jobs",
  VALIDATION_JOBS = "validation_jobs",
}

const TAB_PARAM = "tab";
const DEFAULT_TAB = modelCatalogeTabTypes.TRAINING_JOBS;

export const useTabSelection = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedTab, setSelectedTab] = useState<modelCatalogeTabTypes>(() => {
    const tabParam = searchParams.get(TAB_PARAM);
    const isValidTab = Object.values(modelCatalogeTabTypes).includes(
      tabParam as modelCatalogeTabTypes,
    );
    return isValidTab ? (tabParam as modelCatalogeTabTypes) : DEFAULT_TAB;
  });

  // Update URL when tab changes
  useEffect(() => {
    if (selectedTab === DEFAULT_TAB) {
      searchParams.delete(TAB_PARAM);
    } else {
      searchParams.set(TAB_PARAM, selectedTab);
    }
    // Replace, not push: syncing the URL on load must not add a history entry,
    // otherwise Back lands on the same page and looks broken
    setSearchParams(searchParams, { replace: true });
  }, [selectedTab, searchParams, setSearchParams]);

  const handleResetFilters = useCallback(
    (tab: modelCatalogeTabTypes) => {
      if (tab === DEFAULT_TAB) {
        setSearchParams({});
      } else {
        setSearchParams({ [TAB_PARAM]: tab });
      }
    },
    [setSearchParams],
  );

  const handleTabChange = useCallback(
    (tab: modelCatalogeTabTypes) => {
      setSelectedTab(tab);
      handleResetFilters(tab);
    },
    [handleResetFilters],
  );

  const tabContent = [
    {
      key: "tab1",
      label: "Training Jobs",
      icon: "",
      onclick: () => handleTabChange(modelCatalogeTabTypes.TRAINING_JOBS),
      selected: selectedTab === modelCatalogeTabTypes.TRAINING_JOBS,
      disabled: false,
    },
    {
      key: "tab2",
      label: "Validation Jobs",
      icon: "",
      onclick: () => handleTabChange(modelCatalogeTabTypes.VALIDATION_JOBS),
      selected: selectedTab === modelCatalogeTabTypes.VALIDATION_JOBS,
      disabled: false,
    },
  ];

  return {
    selectedTab: selectedTab || DEFAULT_TAB,
    tabContent,
    setSelectedTab: handleTabChange,
  };
};
